import { Component, Show, createSignal } from "solid-js";

interface ShareResultModalProps {
	isOpen: boolean;
	onClose: () => void;
	url: string;
	isError?: boolean;
}

const ShareResultModal: Component<ShareResultModalProps> = (props) => {
	const [copySuccess, setCopySuccess] = createSignal(false);

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(props.url);
			setCopySuccess(true);
			setTimeout(() => setCopySuccess(false), 2000);
		} catch (err) {
			console.error("Failed to copy:", err);
		}
	};

	return (
		<Show when={props.isOpen}>
			<div
				class="fixed inset-0 bg-opacity-50 flex items-center justify-center z-[10000]"
				onClick={props.onClose}
			>
				<div
					class="bg-white rounded-lg shadow-xl w-full max-w-md mx-4"
					onClick={(e) => e.stopPropagation()}
				>
				<div class="p-6">
					<h2 class="text-xl font-bold text-gray-900 mb-4">
						{props.isError ? "Fel vid delning" : "Scenario delat!"}
					</h2>

					{props.isError ? (
						<>
							<p class="text-sm text-gray-600 mb-6">
								Det gick inte att dela scenariot. Försök igen.
							</p>
							<div class="flex justify-end">
								<button
									onClick={props.onClose}
									class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
								>
									OK
								</button>
							</div>
						</>
					) : (
						<>
					<p class="text-sm text-gray-600 mb-4">
							När du delar länken ser andra scenariot du har
							skapat.
						</p>

						{/* URL Display and Copy */}
						<div class="mb-6">
							<label class="block text-sm font-medium text-gray-700 mb-2">
								Delningslänk
							</label>
							<div class="flex items-center gap-2">
								<input
									type="text"
									value={props.url}
									readonly
									class="flex-1 px-3 py-2 border border-gray-300 rounded text-sm text-gray-700 bg-gray-50 font-mono"
									onClick={(e) => e.currentTarget.select()}
								/>
								<button
									onClick={handleCopy}
									class="px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors flex items-center gap-1.5"
									title="Kopiera till urklipp"
								>
									<Show
										when={copySuccess()}
										fallback={
											<svg
												class="w-4 h-4"
												fill="none"
												stroke="currentColor"
												viewBox="0 0 24 24"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													stroke-width="2"
													d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
												/>
											</svg>
										}
									>
										<svg
											class="w-4 h-4"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												stroke-width="2"
												d="M5 13l4 4L19 7"
											/>
										</svg>
									</Show>
									<span class="text-sm font-medium">
										{copySuccess()
											? "Kopierad!"
											: "Kopiera"}
									</span>
								</button>
							</div>
						</div>

						{/* OK Button */}
						<div class="flex justify-end">
							<button
								onClick={props.onClose}
								class="px-6 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded transition-colors"
							>
						OK
					</button>
				</div>
				</>
			)}
		</div>
	</div>
</div>
		</Show>
	);
};export default ShareResultModal;
